import { Image, Button } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { H2, BodyText } from "src/atoms/typography";
import { SceneLayout } from "src/components/SceneLayout";
import getImageSrc from "src/utils/getImageSrc";

export default function PurchaseSuccess({ onContinue }) {
  const { t } = useTranslation();
  return (
    <SceneLayout
      centerProps={{ width: "320px" }}
      center={
        <>
          <Image src={getImageSrc("thanks.svg")} width="176px" />
          <H2 color="highEmphasis" textAlign="center" mt="24px">
            {t("purchase.success.heading")}
          </H2>
          <BodyText mt="8px" color="mediumEmphasis" textAlign="center">
            {t("purchase.success.text")}
          </BodyText>
        </>
      }
      bottomProps={{ mb: "24px" }}
      bottom={
        <>
          <Button
            variant="containedPrimary"
            onClick={onContinue}
            mt="32px"
            minWidth="120px"
          >
            {t("buttons.continue")}
          </Button>
        </>
      }
    />
  );
}
